<div
  class="body mx-auto min-h-screen overflow-hidden bg-contain bg-right bg-no-repeat bg-[url(assets/structure/imagenDerecha.png)]"
>
  <header>
    <nav
      class="mx-auto flex max-w-9xl items-center justify-between p-2 lg:px-8"
      aria-label="Global"
    >
      <div class="section-logo flex lg:flex-1">
        <a href="#" class="-m-1.5 p-1.5">
          <span class="sr-only">Hola Doc</span>
          <img class="logo-header h-17 w-auto" src="assets/holaDocLogo.png" alt="Hola Doc" />
        </a>
      </div>
    </nav>
  </header>

  <div class="body-content flex flex-row mt-7">
    <div class="left-section w-1/2 ml-20">
      <div class="flex justify-center">
        <div class="w-10/12 flex flex-col items-start">
          <h1
            class="header text-5xl font-bold sm:mb-9 lg:mb-8 text-headers-blue text-left leading-10 text-[41px]"
          >
            ¡Impulsa tu Bienestar!
          </h1>

          <p class="paragraph text-sub-headers-gray text-left sm:mb-14 text-[20px] lg:mb-5">
            Descubre nuestros recursos digitales y avanza hacia una vida más saludable y activa
          </p>

          <div class="right-section-mobile w-full mb-14 rounded-[3px]">
            <swiper-container
              id="swiperContainerMobile"
              class="mySwiper"
              pagination="false"
              navigation="true"
              slides-per-view="3"
              centered-slides="true"
              space-between="10"
              grab-cursor="true"
              initial-slide="1"
            >
              @for (cover of digitalAssets; track cover) {
                <swiper-slide class="rounded-lg">
                  <img
                    width=""
                    [src]="assetsUrl + '/' + cover.img"
                    [alt]="cover.name"
                    class="rounded-lg"
                  />
                </swiper-slide>
              }
            </swiper-container>

            <div
              class="flex flex-row justify-end gap-8 mr-8 navigation-buttons relative z-1 translate-[38px,15px]"
            >
              <img
                class="cursor-pointer"
                width="30"
                src="assets/home/leftArrow.png"
                alt="left"
                id="leftArrow"
                (click)="navigateClickMobile('swiper-button-prev')"
              />
              <img
                class="cursor-pointer"
                width="30"
                src="assets/home/rigthArrow.png"
                alt="right"
                id="rigthArrow"
                (click)="navigateClickMobile('swiper-button-next')"
              />
            </div>
          </div>

          <div class="w-full form-home">
            <form
              [formGroup]="subscriberNgForm"
              class="bg-white rounded-[25px] px-8 pt-6 pb-8 mb-4 form-shadow w-[567px]"
            >
              <div class="mb-3">
                <mat-form-field
                  id="select-ebook"
                  class="w-full justify-start bg-gray-100 rounded shadow"
                  appearance="fill"
                  subscriptSizing="fixed"
                >
                  @if (labelDigitalResource) {
                    <mat-label class="flex label-select-resource ml-6">
                      <img src="assets/logos/select_arrow_down.svg" alt="VZLA" /> &nbsp;
                      <span>Selecciona un recurso</span>
                    </mat-label>
                  }

                  <mat-select [value]="whyDigitalResource">
                    @for (dg of digitalAssets; track $index) {
                      <mat-option
                        [attr.data-itemvalue]="dg._id"
                        #optionRef
                        (click)="itemSeleccionado(optionRef.value)"
                        [value]="dg._id"
                        >{{ dg.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (!SelectDigitalResource) {
                  <div class="error">Selecciona una opción</div>
                }
              </div>

              <div class="div-input-container flex flex-row justify-between gap-5">
                <div class="div-input mb-5 w-1/2 input-form">
                  <label class="block text-gray-700 text-sm font-bold mb-2" for="nombre">
                    Nombre
                  </label>
                  <input
                    formControlName="firstName"
                    maxlength="50"
                    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-8 focus:outline-none focus:shadow-outline"
                    id="nombre"
                    type="text"
                    placeholder="Nombre"
                    [class.error-input]="
                      subscriberNgForm.get('firstName')!.hasError('required') &&
                      (subscriberNgForm.get('firstName')!.dirty ||
                        subscriberNgForm.get('firstName')!.touched)
                    "
                  />

                  @if (
                    subscriberNgForm.get('firstName')!.hasError('required') &&
                    (subscriberNgForm.get('firstName')!.dirty ||
                      subscriberNgForm.get('firstName')!.touched)
                  ) {
                    <div class="error">Ingresa tu nombre</div>
                  }
                </div>

                <div class="div-input mb-5 w-1/2 input-form">
                  <label class="block text-gray-700 text-sm font-bold mb-2" for="apellido">
                    Apellido
                  </label>
                  <input
                    maxlength="50"
                    formControlName="lastName"
                    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-8 focus:outline-none focus:shadow-outline"
                    id="apellido"
                    type="text"
                    placeholder="Apellido"
                    [class.error-input]="
                      subscriberNgForm.get('lastName')!.hasError('required') &&
                      (subscriberNgForm.get('lastName')!.dirty ||
                        subscriberNgForm.get('lastName')!.touched)
                    "
                  />

                  @if (
                    subscriberNgForm.get('lastName')!.hasError('required') &&
                    (subscriberNgForm.get('lastName')!.dirty ||
                      subscriberNgForm.get('lastName')!.touched)
                  ) {
                    <div class="error">Ingresa tu apellido</div>
                  }
                </div>
              </div>

              <div class="mb-5 input-form" (click)="$event.stopPropagation()">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="numero">
                  Número de teléfono
                </label>

                <div class="flex flex-row justify-between gap-5 select-flag-number">
                  <div class="w-1/6 select-flag">
                    <mat-form-field
                      id="select-ebook-flag"
                      class="w-full justify-start bg-gray-100 shadow rounded-[5px] h-[45px] appearance-none"
                      floatLabel="auto"
                    >
                      <mat-icon
                        matPrefix
                        [class]="selectedFlag == 've' ? 'styles-flag-ve' : 'styles-flag-foreign'"
                      >
                        <span
                          class="scale-[0.5] flag-icon flag-icon-squared flag-icon-rounded
													fi fi-{{ selectedFlag }}"
                        >
                        </span>
                        @if (selectedFlag == 've') {
                          <img
                            class="w-[15%]"
                            src="assets/logos/select_arrow_down.svg"
                            alt="VZLA"
                          />
                        }
                      </mat-icon>

                      <mat-select panelWidth="250px" hideSingleSelectionIndicator="false" stop>
                        @if (selectedFlag) {
                          <mat-select-trigger class="selected-flag hidden">
                            <img class="w-[60%]" [src]="selectedFlag" alt="test" />
                          </mat-select-trigger>
                        }

                        <input
                          type="text"
                          id="input-select"
                          matInput
                          class="w-full border-none"
                          placeholder="Buscar"
                          [formControl]="mycontrol"
                          (click)="$event.stopPropagation()"
                        />
                        @for (flag of filteredOptions | async; track $index) {
                          <mat-option
                            [attr.data-itemvalue]="flag.value"
                            #optionRef
                            (click)="
                              selectCountry(optionRef.value, flag.newSvgIcon, $event, flag.id)
                            "
                            [value]="flag.phoneCode"
                            [selected]="flag.value === '+355'"
                            class="flex flex-col"
                          >
                            <mat-icon matPrefix>
                              <span class="fi fi-{{ flag.newSvgIcon }}"></span>
                            </mat-icon>
                            <span> {{ flag.name }} {{ flag.phoneCode }} </span>
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="w-10/12 h-max input-form input-flag-number">
                    <input
                      formControlName="phoneNumber"
                      class="[&::-webkit-inner-spin-button]:appearance-none phone-number shadow appearance-none borde rounded w-full py-2 px-3 text-gray-700 leading-8 focus:outline-none focus:shadow-outline"
                      id="numero"
                      type="number"
                      required
                      placeholder="123465798"
                      [class.error-input]="
                        subscriberNgForm.get('phoneNumber')!.hasError('required') &&
                        (subscriberNgForm.get('phoneNumber')!.dirty ||
                          subscriberNgForm.get('phoneNumber')!.touched)
                      "
                    />
                    @if (
                      subscriberNgForm.get('phoneNumber')!.hasError('required') &&
                      (subscriberNgForm.get('phoneNumber')!.dirty ||
                        subscriberNgForm.get('phoneNumber')!.touched)
                    ) {
                      <div class="error error-telefono">Ingresa tu teléfono</div>
                    }
                  </div>
                </div>
              </div>

              <div class="mb-5 input-form">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="cedula">
                  Cédula de identidad
                </label>
                <input
                  formControlName="identificationNumber"
                  class="[&::-webkit-inner-spin-button]:appearance-none shadow appearance-none border rounded w-full px-3 text-gray-700 leading-8 focus:outline-none focus:shadow-outline"
                  id="cedula"
                  type="text"
                  placeholder="123456789"
                  (keydown)="validateNumber($event)"
                  (blur)="onBlur($event)"
                  [class.error-input]="
                    (subscriberNgForm.get('identificationNumber')!.hasError('required') &&
                      (subscriberNgForm.get('identificationNumber')!.dirty ||
                        subscriberNgForm.get('identificationNumber')!.touched)) ||
                    subscriberNgForm.get('identificationNumber')!.hasError('lengthLocal') ||
                    subscriberNgForm.get('identificationNumber')!.hasError('lengthForeign')
                  "
                />
                <!-- (keypress)=" validateLength($event, 'identificationNumber') " -->

                @if (
                  subscriberNgForm.get('identificationNumber')!.hasError('required') &&
                  (subscriberNgForm.get('identificationNumber')!.dirty ||
                    subscriberNgForm.get('identificationNumber')!.touched)
                ) {
                  <div class="error">Ingresa tu número de cédula</div>
                }

                @if (subscriberNgForm.get('identificationNumber')!.hasError('lengthLocal')) {
                  <div class="error">Debe tener mínimo 5 y máximo 9 dígitos</div>
                }

                @if (subscriberNgForm.get('identificationNumber')!.hasError('lengthForeign')) {
                  <div class="error">Debe tener mínimo 1 y máximo 50 dígitos</div>
                }
              </div>

              <div class="mb-5 form input-form">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
                  Correo electronico
                </label>
                <input
                  formControlName="email"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-8 focus:outline-none focus:shadow-outline"
                  id="email"
                  type="email"
                  required
                  placeholder="correo@gmail.com"
                  [class.error-input]="
                    subscriberNgForm.get('email')!.hasError('required') &&
                    (subscriberNgForm.get('email')!.dirty || subscriberNgForm.get('email')!.touched)
                  "
                />

                @if (
                  subscriberNgForm.get('email')!.hasError('required') &&
                  (subscriberNgForm.get('email')!.dirty || subscriberNgForm.get('email')!.touched)
                ) {
                  <div class="error">Ingresa tu correo electrónico</div>
                }
              </div>

              <div class="section-button flex items-center justify-center mb-5">
                <button
                  [disabled]="!sendForm"
                  [class.button-disabled]="!sendForm"
                  (click)="sendEmail()"
                  class="bg-submit-botton hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline w-full"
                  type="button"
                >
                  <p class="p-1">¡Descargar recurso!</p>
                </button>
              </div>
              <!-- (change)="cheked($event)" -->
              <div class="flex items-center terms-form-inside mt-8">
                <input
                  formControlName="check"
                  id="link-checkbox"
                  type="checkbox"
                  value=""
                  class="w-4 h-4 rounded-sm dark:ring-offset-gray-800 focus:ring-transparent bg-gray-100 dark:border-gray-600"
                />
                <label
                  for="link-checkbox"
                  class="ms-2 text-[64%] text-justify font-medium text-[#6D6B6B]"
                >
                  Al enviar el formulario, aceptas registrarte en HolaDOC y recibir información
                  promocional personalizada a través del correo electrónico y número de teléfono
                  proporcionados. Puedes solicitar la baja en cualquier momento</label
                >
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="right-section-desktop w-6/12">
      <swiper-container
        id="swiperContainerDesktop"
        class="mySwiper"
        space-between="1"
        slides-per-view="auto"
        navigation="true"
        speed="800"
        allowTouchMove="false"
        simulateTouch="false"
        touchRatio="0"
        noSwiping="false"
      >
        @for (cover of digitalAssets; track cover; let i = $index) {
          <swiper-slide class="rounded-lg" [attr.data-position]="i + 1">
            <img [src]="assetsUrl + '/' + cover.img" [alt]="cover.name" class="rounded-lg" />
          </swiper-slide>
        }
        <swiper-slide class="invisible w-[40%]" id="swiper-slide-helper"></swiper-slide>
      </swiper-container>

      <div class="flex flex-row justify-end gap-8 mr-8 navigate-buttons z-1 relative">
        <img
          class="manage-move-prev cursor-pointer"
          width="50"
          src="assets/home/leftArrow.png"
          alt="left"
          id="leftArrow"
          (click)="navigateClick('swiper-button-prev', false, 1)"
        />
        <img
          class="manage-move-next cursor-pointer"
          width="50"
          src="assets/home/rigthArrow.png"
          alt="right"
          id="rigthArrow"
          (click)="navigateClick('swiper-button-next', false, 1)"
        />
      </div>
    </div>
  </div>
</div>
